/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tld_Pricing_Status_AllInputs */

const id_tld_pricing_status_all = /** @type {(inputs: Tld_Pricing_Status_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Semua status`)
};

const en_tld_pricing_status_all = /** @type {(inputs: Tld_Pricing_Status_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Any status`)
};

/**
* | output |
* | --- |
* | "Any status" |
*
* @param {Tld_Pricing_Status_AllInputs} inputs
* @param {{ locale?: "id" | "en" }} options
* @returns {LocalizedString}
*/
export const tld_pricing_status_all = /** @type {((inputs?: Tld_Pricing_Status_AllInputs, options?: { locale?: "id" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tld_Pricing_Status_AllInputs, { locale?: "id" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tld_pricing_status_all(inputs)
	return id_tld_pricing_status_all(inputs)
});